/**
 * Abstract Visitor that provides empty default implementation,
 * so concrete Visitor implementation only needs to implement methods that are required.
 *
 * @public
 */
export class AbstractVisitor {
    visitPluginDefinition(pluginDefinition) {
        // do nothing
    }
    visitGroupStart(pluginGroup) {
        // do nothing
    }
    visitGroupNext(pluginGroup, prevPlugin, nextPlugin) {
        // do nothing
    }
    visitGroupEnd(pluginGroup) {
        // do nothing
    }
    visitMerge(plugin) {
        // do nothing
    }
    visitSplitStart(plugins, splitSource) {
        // do nothing
    }
    visitSplitNext(plugins, prevPlugin, nextPlugin, splitSource) {
        // do nothing
    }
    visitSplitEnd(plugins, splitSource) {
        // do nothing
    }
    visitPipe(prevPlugin, nextPlugin) {
        // do nothing
    }
    visitPlugin(plugin) {
        // do nothing
    }
}
//# sourceMappingURL=Visitor.js.map